// Widget Scripts
import customTicketBtn from './js/widgets/customTicketBtn.js';
import mainFeatureSlideshow from './js/widgets/mainFeatureSlideshow.js';
import autoEventFeed from './js/widgets/autoEventFeed.js';
import updateSignup from './js/widgets/signupFeature.js';
import * as seoSocialWidget from './js/widgets/seo-social/index.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketBtn();

  if (globalThis.location.pathname === '/') {
    mainFeatureSlideshow();
    autoEventFeed();
    updateSignup();
    seoSocialWidget.seoBlock();
    seoSocialWidget.cardWidget();
    scrollerSponsors();
  }
});
